import styled from "styled-components";

import { RadioButton } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import {
    filterCardContainerSetup,
    filterCardWideQuery,
} from "app/pages/sales-intelligence/common-components/filters-panel/components/styles";

const APPS_PLATFORM_CONTAINER = "apps-platform-filter";

export const StyledRadioButton = styled(RadioButton)`
    padding: 0;

    label {
        margin-left: 4px;
    }
`;

export const StyledAppsPlatformContainer = styled.div`
    ${filterCardContainerSetup(APPS_PLATFORM_CONTAINER)}
`;

export const StyledAppsPlatformGroup = styled(Flex)`
    flex-direction: column;
    gap: 12px;

    ${filterCardWideQuery(APPS_PLATFORM_CONTAINER)} {
        flex-direction: row;
        gap: 32px;
    }
`;
